import { IFormValidation } from '@aston/foundation';

export class INewAccountCompanyValidator implements IFormValidation {
	ruleset = 'createSubsidiaryCommandValidator';
	fields = {
		AnnualAccountingDocumentCount: 'AnnualAccountingDocumentCount',
		AnnualFigure: 'AnnualFigure',
		Name: 'Name',
		Street: 'PhysicalAddress.Street',
		ZipCode: 'PhysicalAddress.ZipCode',
		City: 'PhysicalAddress.City',
		Country: 'PhysicalAddress.CountryCode',
		LegalIdentifier: 'LegalIdentifier',
		CurrencyCode: 'CurrencyCode',
	};
}

export const NewAccountCompanyValidator = new INewAccountCompanyValidator();
